import { Tooltip } from 'antd';
import { checkValue, formatDate, truncateString } from 'utils';

export const columns = [
  {
    title: 'Наименование группы',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: 'Количество пользователей',
    dataIndex: 'users',
    key: 'users',
    render: (data) => data?.length,
  },
  {
    title: 'Ответственный группы',
    dataIndex: 'users',
    key: 'users',
    render: (users) => {
      const values = users
        ?.filter((item) => item.isResponsible)
        .map((item) => item.full_name)
        .join(', ');

      const truncated = truncateString(values, 50);

      return (
        <Tooltip placement="bottomLeft" title={values || 'Нету данных'}>
          {checkValue(truncated)}
        </Tooltip>
      );
    },
  },
  {
    title: 'Создан',
    dataIndex: 'created',
    key: 'created',
    render: (value) => formatDate(value),
  },
];
